import { RefreshCwIcon } from "lucide-react";
import type { ComponentProps } from "react";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

type DataTableRefreshButtonProps = Omit<ComponentProps<typeof Button>, "asChild" | "children"> & {
  label: string;
  loadingLabel: string;
  refreshing: boolean;
};

export function DataTableRefreshButton({ disabled, label, loadingLabel, refreshing, size = "lg", variant = "outline", ...props }: DataTableRefreshButtonProps) {
  return (
    <Button disabled={disabled || refreshing} size={size} variant={variant} {...props}>
      {refreshing ? <Spinner aria-label={loadingLabel} data-icon="inline-start" /> : <RefreshCwIcon data-icon="inline-start" />}
      {label}
    </Button>
  );
}
